"use strict";
const utils_1 = require("./utils");
const tz = (0, utils_1.getTz)();
const CALL_CENTRE_OPEN_HOURS = '9am – 6pm';
const MESSAGING_OPEN_HOURS = '8am – 7pm';
const CALL_CENTRE_OPEN_HOURS_STANDARD_COPY = `${CALL_CENTRE_OPEN_HOURS} Monday to Friday`;
const MESSAGING_OPEN_HOURS_STANDARD_COPY = `${MESSAGING_OPEN_HOURS} Monday to Friday`;
const OPEN_INSURANCE_PHONE = '1300 518 049';
const OPEN_INSURANCE_EMERGENCY_PHONE = '(+61) 2 4062 8737';
const BPAY = {
    BILLER_CODE: '57430',
};
const CONTACT = {
    ADDRESS: {
        PHYSICAL: '720 Bourke Street, Docklands, Victoria, 3008',
        POSTAL: 'ahm health insurance, Locked Bag 4, Wetherill Park NSW 2164',
    },
    EMAIL: {
        CONTACT_US_OVERSEAS: 'overseas@ahm.com.au',
        FEEDBACK: 'feedback@ahm.com.au',
        INFO: 'info@ahm.com.au',
        ZENDESK_FEEDBACK: 'newrequests@ahmdigital.zendesk.com',
    },
    HOURS: {
        CAR_AND_HOME: [(0, utils_1.makeHours)('08:00', '18:00', 'Monday to Thursday'), (0, utils_1.makeHours)('08:00', '17:00', 'Friday')],
        LIFE_INSURANCE: [(0, utils_1.makeHours)('08:00', '20:00', 'Monday to Friday'), (0, utils_1.makeHours)('08:00', '17:00', 'Saturday')],
        LIFE_INSURANCE_ZURICH: (0, utils_1.makeHours)('08:00', '20:00', 'Monday to Friday'),
        SALES: (0, utils_1.makeHours)('09:00', '18:00'),
        TRAVEL_INSURANCE: (0, utils_1.makeHours)('08:00', '19:00'),
        TWITTER: (0, utils_1.makeHours)('09:00', '17:00'),
    },
    OPENING_HOURS: {
        CONTACT_CENTRE: {
            EXISTING_CUSTOMERS: CALL_CENTRE_OPEN_HOURS_STANDARD_COPY,
            NEW_CUSTOMERS: CALL_CENTRE_OPEN_HOURS_STANDARD_COPY,
        },
        LIVE_CHAT: {
            EXISTING_CUSTOMERS: MESSAGING_OPEN_HOURS_STANDARD_COPY,
            MACHINE: [
                // Time is in Sydney/Melbourne timezone!
                // e.g. [{ hour: 8, minute: 30 }, { hour: 10 }],
                [{ hour: 0 }, { hour: 0 }], // Sunday
                [{ hour: 9 }, { hour: 18 }], // Mon
                [{ hour: 9 }, { hour: 18 }], // Tue
                [{ hour: 9 }, { hour: 18 }], // Wed
                [{ hour: 9 }, { hour: 18 }], // Thu
                [{ hour: 9 }, { hour: 18 }], // Fri
                [{ hour: 0 }, { hour: 0 }], // Sat
            ],
            WIDGET: `${CALL_CENTRE_OPEN_HOURS} Weekdays (${tz})`,
        },
        TWITTER: `9am – 5pm Monday to Friday (${tz})`,
    },
    PHONE: {
        CAR_INSURANCE: OPEN_INSURANCE_PHONE,
        CAR_INSURANCE_EMERGENCY: OPEN_INSURANCE_EMERGENCY_PHONE,
        HOME_INSURANCE: OPEN_INSURANCE_PHONE,
        HOME_INSURANCE_EMERGENCY: OPEN_INSURANCE_EMERGENCY_PHONE,
        INTERNATIONAL_PRETTY: '(+61) 3 8329 1520',
        INTERNATIONAL_STANDARD: '+61383291520',
        PRETTY: '134 246',
        SMS_PRETTY: '0439 183 474',
        SMS_STANDARD: '+61439183474',
        STANDARD: '134246',
    },
};
const HEALTH_FUND = {
    AAMI: 'AAMI',
    ACA: 'ACA Health',
    APIA: 'APIA',
    AUSTRALIAN_COUNTRY_HEALTH: 'Australian Country Health',
    AUSTRALIAN_UNITY: 'Australian Unity',
    BUDGET_DIRECT: 'Budget Direct',
    BUPA: 'BUPA',
    CBHS: 'CBHS',
    CDH: 'CDH',
    CENTRAL_WEST: 'Central West Health',
    COUNTRY_HEALTH: 'Country Health',
    CREDICARE: 'Credicare',
    CUA: 'CUA',
    CY_HEALTH: 'CY Health',
    DEFENCE: 'DefenceHealth',
    DOCTORS: 'Doctors Health Fund',
    DRUIDS: 'Druids',
    FEDERATION_HEALTH: 'Federation Health',
    FIT: 'Fit',
    FRANK: 'Frank',
    GMF: 'GMF',
    GMHBA: 'GMHBA',
    GOLDFIELDS: 'Goldfields',
    GRAND_UNITED: 'Grand United',
    GU: 'GU Health',
    HBA: 'HBA',
    HBF: 'HBF',
    HCF: 'HCF',
    HEALTH_CARE_INSURANCE: 'Health Care Insurance',
    HEALTH_COM_AU: 'Health.com.au',
    HEALTH_PARTNERS: 'Health Partners',
    HEALTHGUARD: 'Healthguard',
    HIF: 'HIF',
    ILLAWARRA_HEALTH_FUND: 'Illawarra Health Fund',
    IMAN: 'IMAN',
    IOOF: 'IOOF',
    IOR: 'IOR',
    LATROBE: 'Latrobe',
    MANCHESTER_UNITY: 'Manchester Unity',
    MBF: 'MBF',
    MDHF: 'MDHF',
    MEDIBANK: 'Medibank Private',
    MUTUAL_COMMUNITY: 'Mutual Community',
    MUTUAL_HEALTH: 'Mutual Health',
    MY_OWN: 'myOwn',
    NAVY: 'Navy Health',
    NRMA_HEALTH: 'NRMA Health',
    NIB: 'NIB',
    NSW_TEACHERS_FEDERATION: 'NSW Teachers Federation',
    NURSES_AND_MIDWIVES_HEALTH: 'Nurses & Midwives Health',
    ONEMEDIFUND: 'Onemedifund',
    OTHER: 'Other',
    PEOPLECARE: 'Peoplecare',
    PHOENIX: 'Phoenix Health Fund',
    POLICE: 'Police Health Fund',
    QANTAS_ASSURE: 'Qantas Assure',
    QUEENSLAND_COUNTRY: 'Queensland Country Health',
    QUEENSLAND_TEACHERS_UNION: 'Queensland Teachers Union',
    RACT: 'RACT',
    RBHS: 'RBHS',
    RT: 'RT Health Fund',
    SGIC_SA: 'SGIC (SA)',
    SGIC_WA: 'SGIC (WA)',
    ST_LUKES: 'St. Lukes Health',
    SUNCORP: 'Suncorp',
    TEACHERS_HEALTH: 'Teachers Health',
    TRANSPORT: 'Transport Health',
    UNIHEALTH: 'Unihealth',
    WESTFUND: 'Westfund Health',
};
module.exports = {
    BPAY,
    CALL_CENTRE_OPEN_HOURS,
    CONTACT,
    HEALTH_FUND,
    MESSAGING_OPEN_HOURS,
    OPEN_INSURANCE_PHONE,
    OPEN_INSURANCE_EMERGENCY_PHONE,
    CALL_CENTRE_OPEN_HOURS_STANDARD_COPY,
    MESSAGING_OPEN_HOURS_STANDARD_COPY,
};
